const organisationIdBrand = Symbol();
export type OrganisationId = (number | string) & { [organisationIdBrand]: null };

export interface Organisation {
    Id: OrganisationId;
    Name: string;
    LongName: string;
}

export interface OrganisationStatistics {
    Storage: {
        Records: StorageStatistic;
        AipRecords: StorageStatistic;
    };
    Objects: OrganisationAssets;
}

export interface OrganisationAssets {
    Records: OrganisationObjectCounts;
    AipRecords: OrganisationObjectCounts;
    Users: OrganisationObjectCounts;
    Groups: OrganisationObjectCounts;
    Zones: OrganisationObjectCounts;
    Exports: OrganisationObjectCounts;
    Roles: OrganisationObjectCounts;
    Filters: OrganisationObjectCounts;
}

export interface StorageStatistic {
    Value: number;
    Unit: StorageUnit;
}

export enum StorageUnit {
    B = 'B',
    KB = 'Kb',
    MB = 'Mb',
    GB = 'Gb',
    TB = 'Tb',
    PB = 'Pb',
    EB = 'Eb'
}

export interface OrganisationObjectCounts {
    Total: number;
    [Label: string]: number;
}
